@use '../../styling/colors.scss' as *;

/* stylelint-disable */
:export {
  step0: $color-primary-purple;
  step1: $color-primary-purple-light;
  step2: $color-primary-purple-hover;
  step3: $color-grey-B;
  step4: $color-secondary-green;

  step5: $color-primary-blue-hover;
  step6: $color-action-back;
  step7: $color-secondary-blue;
  step8: $color-state-initial;
  step9: $color-tag-font;
  
  step10: $color-focus-shadow;
  step11: $color-primary-red;
  step12: $color-warning-orange-hover;
  step13: $color-primary-purple-active;
  step14: $color-state-default;

  step15: $color-action-exit;
  step16: $color-grey-disabled;
  step17: $color-secondary-green-hover;
  step18: $color-primary-blue-light;
  step19: $color-primary-green-hover;

  step20: $color-secondary-purple;
  step21: $color-grey-C;
  step22: $color-primary-red-hover;
  step23: $color-secondary-button-hover;
  step24: $color-grey-A;
  
  step25: $color-warning-orange;
  step26: $color-primary-red-active;
}

/* stylelint-enable */
.chartContainerStyle {
  position: 'relative';
  min-height: 29.5em;
}
